<template>
  <div>
    <div class="col-md-6 appinfopage">
      <h4 class="h4-title">iOS Provider details</h4>
      <form v-on:submit.prevent="saveiOSProviderDetail">
        <div class="form-group ">
          <label for="formGroupExampleInput">Team Id</label>
          <input
            type="text"
            class="form-control"
            id="teamid"
            placeholder="Required"
            v-model="formIOSProvider.teamId"
          >
        </div>
        <div class="form-group ">
          <label for="formGroupExampleInput">Key Id</label>
          <input
            type="text"
            class="form-control"
            id="keyid"
            placeholder="Required"
            v-model="formIOSProvider.keyId"
          >
        </div>
        <div class="form-group ">
          <label for="formGroupExampleInput">Bundle Id</label>
          <input
            type="text"
            class="form-control"
            id="bundleid"
            placeholder="Required"
            v-model="formIOSProvider.bundleId"
          >
        </div>
        <div class="form-group ">
          <label for="formGroupExampleInput">p8 File</label>
          <b-form-file
            placeholder="choose your p8 file"
            v-model="formIOSProvider.p8"
            :state="Boolean(formIOSProvider.p8)"
          ></b-form-file>
        </div>
        <hr />
        <div>
          <div class="form-group row">
            <div class="col-sm-2">
              <button
                type="submit"
                class="btn btn-primary"
              >{{saveButtonLabel}}</button>
            </div>
            <div class="col-sm-2">
              <button
                type="button"
                class="btn btn-danger"
                @click="deleteProvider"
                v-if="pageMode===1"
              >Delete</button>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-12">
              <b-alert
                show
                variant="success"
                v-if="saveDone"
              >Successfully saved.</b-alert>
              <b-alert
                show
                variant="danger"
                v-if="isError"
              >{{errorMessage}}</b-alert>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import IOSProvider from '@/models/iosprovider.js';

export default {
  data () {
    return {
      appId: '',
      isoProviderId: '',
      isError: false,
      saveDone: false,
      pageMode: 0, // 0 = Entry, 1 = Edit
      errorMessage: '',
      saveButtonLabel: 'Create',
      currentPage: 1,
      totalRows: 1,
      formIOSProvider: {}
    };
  },
  methods: {
    getiOSPrivderDetail () {
      this.appId = this.$route.params.id;
      this.axios.get(`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/ios-provider/`, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(response => {
          const iosProvider = response.data.data.iosProvider;
          if (iosProvider) {
            this.formIOSProvider = new IOSProvider(iosProvider);
            this.pageMode = 1;
            this.saveButtonLabel = 'Update';
          }
        })
        .catch(error => {
          console.log(error);
          this.isError = true;
          this.handleError(error);
        });
    },
    saveiOSProviderDetail () {
      if (0 === this.pageMode) {
        // Create
        this.createProvider();
      } else if (1 === this.pageMode) {
        // Update
        this.updateProvider();
      }
    },
    deleteProvider () {
      if (confirm('Are you sure to delete this provider detail?')) {
        this.axios({
          method: 'delete',
          url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/ios-provider/${this.formIOSProvider.id}`)
        }).then(res => {
          const respData = res.data;
          if ('Success' === respData.message) {
            this.saveDone = true;
            this.goToAppList();
          }
        })
          .catch(error => {
            this.isError = true;
            console.log('Error :', error.response);
            this.handleError(error);
          });
      }
    },
    createProvider () {
      const iosProvider = new IOSProvider(this.formIOSProvider);
      const fd = new FormData();

      for (let key in iosProvider) {
        if (iosProvider[key]) {
          fd.append(key, iosProvider[key]);
        }
      }

      this.axios({
        method: 'post',
        url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/ios-provider`),
        data: fd,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(res => {
        const respData = res.data;
        if ('Success' === respData.message) {
          this.saveDone = true;
          this.goToAppList();
        }
      })
        .catch(error => {
          this.isError = true;
          this.handleError(error);
        });
    },
    updateProvider () {
      const fd = new FormData();

      for (let key in this.formIOSProvider) {
        fd.append(key, this.formIOSProvider[key]);
      }

      this.axios({
        method: 'patch',
        url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}/ios-provider/${this.formIOSProvider.id}`),
        data: fd,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(res => {
        const respData = res.data;
        if ('Success' === respData.message) {
          this.saveDone = true;
          this.goToAppList();
        }
      })
        .catch(error => {
          this.isError = true;
          this.handleError(error);
        });
    },
    goToAppList (id) {
      this.$router.push({ name: 'messaging-app-list' });
    },
    handleError (error) {
      if (error.response.data.data.length > 0) {
        this.errorMessage = error.response.data.data.map(value => value.msg).join(', ');
      } else {
        this.errorMessage = error.response.data.data.message;
      }
    }
  },
  created () {
    this.getiOSPrivderDetail();
    document.title = 'Admin Console: iOS Provider Detail';
  }
};
</script>
